/** @file AI view state: the actor filter (null = all) and the entry open full size (by seq). */
import { createStore } from 'zustand/vanilla';

/** Shared by the panel and the Activity badge link. */
export interface AiViewState {
  actor: string | null;
  open: number | null;
}

/** Vanilla store; survives the panel being hidden. */
export const aiViewStore = createStore<AiViewState>()(() => ({ actor: null, open: null }));
